import { render, staticRenderFns } from "./UsageInfoBox.vue?vue&type=template&id=3b24efd4&"
import script from "./UsageInfoBox.vue?vue&type=script&lang=js&"
export * from "./UsageInfoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports